import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-menu',
  templateUrl: './breadcrumb-menu.component.html',
  styleUrls: ['./breadcrumb-menu.component.scss']
})
export class BreadcrumbMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
